import { type ReactElement, type ReactNode } from 'react'

import { ClickGuard } from '@orus.eu/pharaoh-next/components/ui/click-guard'
import { Item } from '@orus.eu/pharaoh-next/components/ui/item'

type ContactLinkItemProps = {
  icon: ReactNode
  label: string
  href: string
}

export function ContactLinkItem({ icon, label, href }: ContactLinkItemProps): ReactElement {
  return (
    <Item.Root interactive render={<ClickGuard href={href} />}>
      <Item.Media className="size-[32px]">{icon}</Item.Media>
      <Item.Content>
        <Item.Title weight="regular">{label}</Item.Title>
      </Item.Content>
      <Item.Actions>
        <Item.Chevron />
      </Item.Actions>
    </Item.Root>
  )
}
